import SvgIcon from '@mui/material/SvgIcon';

const ExportSvgIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M12 4.99994L11.293 4.29294L12 3.58594L12.707 4.29294L12 4.99994ZM13 13.9999C13 14.2652 12.8946 14.5195 12.7071 14.707C12.5195 14.8946 12.2652 14.9999 12 14.9999C11.7348 14.9999 11.4804 14.8946 11.2929 14.707C11.1053 14.5195 11 14.2652 11 13.9999H13ZM6.29297 9.29294L11.293 4.29294L12.707 5.70694L7.70697 10.7069L6.29297 9.29294ZM12.707 4.29294L17.707 9.29294L16.293 10.7069L11.293 5.70694L12.707 4.29294ZM13 4.99994V13.9999H11V4.99994H13Z"
      fill="currentColor"
    />
    <path d="M5 16V17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V16" stroke="currentColor" strokeWidth="2" />
  </SvgIcon>
);

export default ExportSvgIcon;
